import * as React from 'react';
import { FindingTypePropertyTemplateType } from '../FindingTypePropertyTemplate/findingTypePropertyTemplate.slice';
import { Table } from 'antd';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import type { SortEnd, SortableContainerProps } from 'react-sortable-hoc';
import { MenuOutlined } from '@ant-design/icons';
import './FindingTypeTemplate.module.scss';

export interface IFindingTypePropertyTableProps {
  columns: any;
  dataSource: FindingTypePropertyTemplateType[];
  setDataSource: React.Dispatch<React.SetStateAction<FindingTypePropertyTemplateType[]>>;
  rowKey: any;
}

const DragHandle = SortableHandle(() => <MenuOutlined style={{ cursor: 'grab', color: '#999' }} />);
const SortableItem = SortableElement((props: any) => <tr {...props} style={{ zIndex: 100000 }} />);
const SortableBody = SortableContainer((props: any) => <tbody {...props} />);

export function FindingTypePropertyTable({ columns, dataSource, setDataSource, rowKey }: IFindingTypePropertyTableProps) {
  const dragColumn = {
    title: 'Sort',
    dataIndex: 'sort',
    width: 30,
    className: 'dragVisible',
    render: () => <DragHandle />
  };

  const onSortEnd = ({ oldIndex, newIndex }: SortEnd) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(dataSource.slice(), oldIndex, newIndex).filter((el: any) => !!el);
      console.log('Sorted items: ', newData);
      setDataSource(newData);
    }
  };

  const DraggableContainer = (props: SortableContainerProps) => (
    <SortableBody useDragHandle disableAutoscroll helperClass='rowDragging' onSortEnd={onSortEnd} {...props} />
  );

  const DraggableBodyRow: React.FC<any> = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = dataSource.findIndex(x => x.id === restProps['data-row-key']);
    return <SortableItem index={index} {...restProps} />;
  };
  return (
    <Table
      columns={[dragColumn, ...columns]}
      dataSource={dataSource}
      rowKey={rowKey}
      components={{ body: { wrapper: DraggableContainer, row: DraggableBodyRow } }}
    ></Table>
  );
}
